const gmatVerbal = [
  {
    id: 101,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 90,
    question: "Every member of the chess club practices at least three times a week. Meera practices three times a week. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. Meera is a member of the chess club.",
      "B. Meera may or may not be a member of the chess club.",
      "C. Meera practices more than anyone else.",
      "D. All students practice three times a week."
    ],
    answer: "B"
  },

  {
    id: 102,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 406,
    discrimination: 0.85,
    timeLimit: 95,
    question: "A company reduced its advertising budget by 50% last quarter, and sales fell by 10% in the same period. The marketing head concludes that the budget cut caused the drop in sales. Which of the following, if true, would most weaken this conclusion?",
    image: null,
    options: [
      "A. The company's main competitor launched a major new product during the same quarter.",
      "B. Advertising has historically driven company sales.",
      "C. The budget cut was approved by the board.",
      "D. Sales had been rising before the cut."
    ],
    answer: "A"
  },

  {
    id: 103,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 413,
    discrimination: 0.86,
    timeLimit: 95,
    question: "All the paintings in the gallery were created before 1950. This painting was created in 1945. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. This painting is in the gallery.",
      "B. This painting could be in the gallery.",
      "C. This painting is not in the gallery.",
      "D. All paintings from 1945 are in this gallery."
    ],
    answer: "B"
  },

  {
    id: 104,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.86,
    timeLimit: 100,
    question: "Students who complete an optional workshop score higher on average on the final exam than those who do not. The dean concludes that the workshop improves exam performance. Which of the following, if true, most weakens this conclusion?",
    image: null,
    options: [
      "A. The workshop is held on weekends.",
      "B. Students who choose to attend the workshop tend to be the most motivated students to begin with.",
      "C. The workshop covers exam topics.",
      "D. Few students attend the workshop."
    ],
    answer: "B"
  },

  {
    id: 105,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 427,
    discrimination: 0.87,
    timeLimit: 100,
    question: "If it rains, the outdoor concert will be cancelled. It did not rain. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. The concert was held.",
      "B. The concert was cancelled.",
      "C. Nothing can be concluded about whether the concert was held.",
      "D. It will rain tomorrow."
    ],
    answer: "C"
  },

  {
    id: 106,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 434,
    discrimination: 0.87,
    timeLimit: 105,
    question: "A fitness app claims that users who log their meals lose more weight than users who do not. Which of the following would be most useful to evaluate this claim?",
    image: null,
    options: [
      "A. Whether users who log meals also exercise more than those who do not.",
      "B. The price of the app.",
      "C. The number of employees at the app company.",
      "D. The app's user interface design."
    ],
    answer: "A"
  },

  {
    id: 107,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.88,
    timeLimit: 105,
    question: "Every winner of the annual bake-off has used real butter in their recipe. Priya used real butter in her recipe. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. Priya won the bake-off.",
      "B. Priya may or may not have won the bake-off.",
      "C. Priya did not win the bake-off.",
      "D. Only butter-based recipes are allowed."
    ],
    answer: "B"
  },

  {
    id: 108,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 447,
    discrimination: 0.88,
    timeLimit: 110,
    question: "A city installed speed cameras on a highway, and accidents there decreased by 30% over the next year. The city council concludes the cameras caused the decrease. Which of the following would most strengthen this conclusion?",
    image: null,
    options: [
      "A. Similar highways without cameras saw no significant change in accidents during the same year.",
      "B. The cameras were expensive to install.",
      "C. Drivers dislike speed cameras.",
      "D. The highway is heavily used."
    ],
    answer: "A"
  },

  {
    id: 109,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 453,
    discrimination: 0.89,
    timeLimit: 110,
    question: "All members of the debate team attend Friday practice. Arjun attends Friday practice. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. Arjun is a member of the debate team.",
      "B. Arjun may or may not be a member of the debate team.",
      "C. Arjun is the team captain.",
      "D. Only debate team members attend Friday practice."
    ],
    answer: "B"
  },

  {
    id: 110,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 460,
    discrimination: 0.89,
    timeLimit: 112,
    question: "A bakery's new packaging reduces plastic waste, and the owner claims it will also increase sales. Which of the following, if true, would most weaken this claim?",
    image: null,
    options: [
      "A. Customer surveys show most buyers choose the bakery based on taste, not packaging.",
      "B. The new packaging costs more to produce.",
      "C. The bakery has been open for ten years.",
      "D. Plastic waste harms the environment."
    ],
    answer: "A"
  },

  {
    id: 111,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 467,
    discrimination: 0.9,
    timeLimit: 115,
    question: "If the museum is open, then the ticket booth is staffed. The ticket booth is staffed. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. The museum is open.",
      "B. The museum may or may not be open.",
      "C. The museum is closed.",
      "D. The ticket booth is always staffed."
    ],
    answer: "B"
  },

  {
    id: 112,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 473,
    discrimination: 0.9,
    timeLimit: 115,
    question: "A survey shows employees who take short breaks every hour report higher job satisfaction. The HR manager concludes mandating hourly breaks will raise satisfaction for everyone. Which of the following would most weaken this conclusion?",
    image: null,
    options: [
      "A. Employees who already enjoy their work may be more likely to take breaks voluntarily.",
      "B. Breaks reduce total working hours.",
      "C. Some employees prefer longer breaks.",
      "D. The survey included only 50 employees."
    ],
    answer: "A"
  },

  {
    id: 113,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 480,
    discrimination: 0.91,
    timeLimit: 118,
    question: "Every laptop sold by this store comes with a two-year warranty. This laptop has a two-year warranty. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. This laptop was sold by this store.",
      "B. This laptop may or may not have been sold by this store.",
      "C. This laptop is defective.",
      "D. All laptops with warranties are from this store."
    ],
    answer: "B"
  },

  {
    id: 114,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 487,
    discrimination: 0.91,
    timeLimit: 118,
    question: "A restaurant chain that switched to biodegradable packaging saw a rise in customer visits the following month. The owner claims the packaging change caused the rise. Which of the following would most weaken this claim?",
    image: null,
    options: [
      "A. The restaurant also launched a popular new menu item that same month.",
      "B. Biodegradable packaging is costlier.",
      "C. Customers dislike plastic packaging.",
      "D. The chain has several locations."
    ],
    answer: "A"
  },

  {
    id: 115,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 0.92,
    timeLimit: 120,
    question: "All flights departing from Gate 12 go to international destinations. This flight departs from Gate 12. Which of the following can be properly concluded?",
    image: null,
    options: [
      "A. This flight goes to an international destination.",
      "B. This flight may or may not go to an international destination.",
      "C. This flight is delayed.",
      "D. Gate 12 is only for domestic flights."
    ],
    answer: "A"
  },

  {
    id: 116,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 500,
    discrimination: 1.1,
    timeLimit: 120,
    question: "The new office design removes assigned desks in favor of open seating, aiming to increase collaboration. Management argues this will boost team productivity. Which of the following is an assumption underlying management's argument?",
    image: null,
    options: [
      "A. Employees prefer working in teams over adjusting seating each day.",
      "B. Increased physical proximity and interaction among employees will lead to more collaboration that translates into higher productivity.",
      "C. Open seating reduces real estate costs.",
      "D. Some employees dislike change."
    ],
    answer: "B"
  },

  {
    id: 117,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 508,
    discrimination: 1.1,
    timeLimit: 125,
    question: "A pharmaceutical company reports that patients taking its new drug recovered faster than those in a historical control group who took no medication. The company concludes the drug speeds recovery. Which of the following, if true, most weakens this conclusion?",
    image: null,
    options: [
      "A. The new patients received more attentive medical care and monitoring than the historical control group did.",
      "B. The drug is more expensive than older treatments.",
      "C. Some patients experienced mild side effects.",
      "D. The study lasted six months."
    ],
    answer: "A"
  },

  {
    id: 118,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 515,
    discrimination: 1.12,
    timeLimit: 128,
    question: "Researchers claim that a new teaching method, which incorporates more group work, improves student retention of material better than traditional lecture-only instruction. Which of the following, if true, would most strengthen this claim?",
    image: null,
    options: [
      "A. Students in classes using the new method scored significantly higher on retention tests a month later, even after controlling for prior academic performance.",
      "B. The new method takes more class time to implement.",
      "C. Teachers find the new method more engaging to teach.",
      "D. Group work requires more classroom space."
    ],
    answer: "A"
  },

  {
    id: 119,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 522,
    discrimination: 1.12,
    timeLimit: 130,
    question: "In the past decade, the number of electric vehicles on the road has increased tenfold, while the number of gasoline stations has decreased by 15%. Which of the following can be most properly inferred from this information?",
    image: null,
    options: [
      "A. Electric vehicles are now more popular than gasoline vehicles.",
      "B. Some gasoline stations may have closed due to reduced demand for gasoline fuel.",
      "C. Electric vehicles are cheaper than gasoline vehicles.",
      "D. All new vehicles sold are electric."
    ],
    answer: "B"
  },

  {
    id: 120,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 530,
    discrimination: 1.13,
    timeLimit: 132,
    question: "A nutritionist argues that because people who eat breakfast tend to have healthier body weights than people who skip breakfast, everyone should eat breakfast to maintain a healthy weight. Which of the following identifies a flaw in the nutritionist's reasoning?",
    image: null,
    options: [
      "A. The argument assumes that a correlation between eating breakfast and healthy weight implies breakfast causes the healthy weight, ignoring other possible explanations.",
      "B. The argument uses statistics from an unreliable source.",
      "C. The argument fails to define what a healthy weight is precisely.",
      "D. The argument does not mention what foods should be eaten for breakfast."
    ],
    answer: "A"
  },

  {
    id: 121,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 538,
    discrimination: 1.13,
    timeLimit: 135,
    question: "A city plans to build a new light-rail line, arguing it will reduce traffic congestion by giving commuters an alternative to driving. Which of the following would be most useful to know in evaluating this plan?",
    image: null,
    options: [
      "A. What percentage of current commuters would realistically switch from driving to using the light-rail line.",
      "B. The construction cost of the light-rail line.",
      "C. The color scheme of the light-rail cars.",
      "D. How many stations the light-rail line will have."
    ],
    answer: "A"
  },

  {
    id: 122,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 545,
    discrimination: 1.14,
    timeLimit: 138,
    question: "A company's revenue increased by 20% last year, yet its net profit declined compared to the previous year. Which of the following, if true, would best explain this apparent discrepancy?",
    image: null,
    options: [
      "A. The company's operating costs and raw material prices rose at a faster rate than its revenue.",
      "B. The company hired more salespeople.",
      "C. The company's stock price rose.",
      "D. The company expanded into new markets."
    ],
    answer: "A"
  },

  {
    id: 123,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 552,
    discrimination: 1.14,
    timeLimit: 140,
    question: "A city council proposes banning plastic bags in grocery stores, arguing this will significantly reduce litter in local parks. Which of the following is an assumption necessary for the council's argument?",
    image: null,
    options: [
      "A. Plastic bags currently make up a significant portion of the litter found in local parks.",
      "B. Grocery stores will comply with the ban.",
      "C. Reusable bags are more expensive than plastic ones.",
      "D. Other cities have implemented similar bans."
    ],
    answer: "A"
  },

  {
    id: 124,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 560,
    discrimination: 1.15,
    timeLimit: 142,
    question: "A software company observes that customers who use its mobile app spend more money on average than customers who only use its website. The company concludes that promoting app usage will increase overall customer spending. Which of the following, if true, most weakens this conclusion?",
    image: null,
    options: [
      "A. Customers who already intend to spend more may be more inclined to download and use the app in the first place.",
      "B. The app has a lower star rating than the website.",
      "C. The app was released two years after the website.",
      "D. Some customers use both the app and the website."
    ],
    answer: "A"
  },

  {
    id: 125,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 568,
    discrimination: 1.15,
    timeLimit: 145,
    question: "A school district claims that reducing class sizes from 30 to 20 students will improve standardized test scores. Which of the following, if true, would most strengthen the district's claim?",
    image: null,
    options: [
      "A. A pilot program in similar schools that reduced class sizes to 20 saw test scores rise significantly more than in schools that kept class sizes at 30, controlling for other factors.",
      "B. Teachers prefer smaller classes.",
      "C. Smaller classes require more classrooms.",
      "D. The district has sufficient budget for more teachers."
    ],
    answer: "A"
  },

  {
    id: 126,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.16,
    timeLimit: 145,
    question: "Sales of physical books have remained stable over the past five years even as e-book sales have grown substantially. Which of the following can be most properly inferred from this information?",
    image: null,
    options: [
      "A. Total book sales have declined overall.",
      "B. E-book growth has not come primarily at the expense of physical book sales.",
      "C. Physical books are more popular than e-books.",
      "D. E-books are cheaper than physical books."
    ],
    answer: "B"
  },

  {
    id: 127,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 582,
    discrimination: 1.16,
    timeLimit: 148,
    question: "A city official argues that because crime rates dropped after new streetlights were installed downtown, the streetlights caused the drop in crime. Which of the following best identifies a flaw in this reasoning?",
    image: null,
    options: [
      "A. The argument overlooks other factors, such as increased police patrols, that occurred around the same time and could also explain the drop in crime.",
      "B. The argument does not specify the cost of the streetlights.",
      "C. The argument fails to mention when the streetlights were installed.",
      "D. The argument does not compare crime rates in other cities."
    ],
    answer: "A"
  },

  {
    id: 128,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 590,
    discrimination: 1.17,
    timeLimit: 148,
    question: "A company is considering switching all its delivery trucks to electric vehicles to reduce operating costs. Which of the following would be most important to determine before making this decision?",
    image: null,
    options: [
      "A. Whether the cost savings on fuel and maintenance over time would offset the higher upfront purchase cost of electric trucks.",
      "B. The color of the current delivery trucks.",
      "C. How many trucks the company currently owns.",
      "D. The company's founding year."
    ],
    answer: "A"
  },

  {
    id: 129,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.18,
    timeLimit: 150,
    question: "A gym chain plans to open 24-hour locations, arguing this will attract members who currently do not join because of limited operating hours. Which of the following is an assumption underlying this argument?",
    image: null,
    options: [
      "A. A meaningful number of potential members are deterred specifically by the gym's current limited hours, rather than by other factors such as price or location.",
      "B. 24-hour operation costs more in electricity.",
      "C. Some members prefer working out in groups.",
      "D. Other gyms already offer 24-hour access."
    ],
    answer: "A"
  },

  {
    id: 130,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 620,
    discrimination: 1.19,
    timeLimit: 150,
    question: "A study suggests that employees who work remotely at least two days a week report higher job satisfaction than those who work in the office full-time. Which of the following, if true, would most strengthen the study's implied claim that remote work causes higher satisfaction?",
    image: null,
    options: [
      "A. Employees were randomly assigned to remote or in-office schedules, and satisfaction was measured only after the assignment, controlling for prior job satisfaction.",
      "B. Remote employees save money on commuting.",
      "C. The study included 500 participants.",
      "D. Some in-office employees also enjoy their jobs."
    ],
    answer: "A"
  },

  {
    id: 131,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 150,
    question: "A publisher argues that because its bestselling novels are almost always written in first person, aspiring authors should write their novels in first person to maximize sales potential. Which of the following, if true, most seriously undermines the publisher's argument?",
    image: null,
    options: [
      "A. Many novels written in first person are not bestsellers, and many bestsellers are not written in first person, once genre and marketing budget are accounted for.",
      "B. Some readers prefer third-person narration.",
      "C. First-person narration is harder to write for beginning authors.",
      "D. Bestselling novels usually have simple plots."
    ],
    answer: "A"
  },

  {
    id: 132,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 638,
    discrimination: 1.41,
    timeLimit: 155,
    question: "A study found that regions with more coffee shops per capita also have higher rates of small business success. A columnist concludes that opening more coffee shops in a region will boost small business success there. Which of the following best describes a flaw in the columnist's reasoning?",
    image: null,
    options: [
      "A. The argument treats a correlation, which may result from both variables being driven by a third factor such as general economic prosperity, as if it were a direct causal relationship.",
      "B. The argument does not define \"small business success\" precisely.",
      "C. The argument assumes all coffee shops are profitable.",
      "D. The argument does not mention the price of coffee."
    ],
    answer: "A"
  },

  {
    id: 133,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 645,
    discrimination: 1.42,
    timeLimit: 158,
    question: "An airline argues that because a competitor eliminated first-class seating and increased profits the following year, the airline should also eliminate first-class seating to increase its own profits. Which of the following is an assumption required by the airline's argument?",
    image: null,
    options: [
      "A. The competitor's profit increase was primarily attributable to the elimination of first-class seating rather than to other factors, such as fuel price changes or route expansion, that year.",
      "B. First-class seating is unpopular with most travelers.",
      "C. The airline currently operates at a loss.",
      "D. Economy seating is more profitable per square foot than first-class seating."
    ],
    answer: "A"
  },

  {
    id: 134,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 653,
    discrimination: 1.42,
    timeLimit: 160,
    question: "A city's downtown retail sales rose 15% in the year after a new parking garage opened nearby. City officials attribute this rise to the improved parking availability. Which of the following, if true, most seriously weakens this attribution?",
    image: null,
    options: [
      "A. A major new office tower with 2,000 employees also opened downtown that same year, bringing many more potential shoppers to the area regardless of parking.",
      "B. The parking garage charges an hourly fee.",
      "C. Some shoppers still prefer to walk downtown.",
      "D. The parking garage has five levels."
    ],
    answer: "A"
  },

  {
    id: 135,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 660,
    discrimination: 1.43,
    timeLimit: 162,
    question: "A venture capital firm is deciding whether to invest in a startup based on the claim that the startup's user base has grown 300% in the past year. Which of the following would be most important to determine in evaluating whether this growth supports the investment?",
    image: null,
    options: [
      "A. Whether the growth in users has been accompanied by corresponding growth in revenue or engagement, rather than resulting mainly from a temporary free promotional giveaway.",
      "B. The number of employees at the startup.",
      "C. The founder's educational background.",
      "D. The color scheme of the startup's app."
    ],
    answer: "A"
  },

  {
    id: 136,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 668,
    discrimination: 1.43,
    timeLimit: 165,
    question: "Although the average price of a plane ticket on a certain route increased by 10% last year, the airline operating that route reported a 5% decline in total ticket revenue from that route. Which of the following, if true, best resolves this apparent paradox?",
    image: null,
    options: [
      "A. The number of passengers flying that route decreased by more than 10% during the same period, more than offsetting the effect of the higher average price.",
      "B. The airline added more flights on the route.",
      "C. The airline's fuel costs increased.",
      "D. Competing airlines lowered their prices on other routes."
    ],
    answer: "A"
  },

  {
    id: 137,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 675,
    discrimination: 1.44,
    timeLimit: 168,
    question: "A manager argues that because the sales team met its quarterly target only after switching to a new customer relationship management (CRM) software, the company should adopt the same CRM software company-wide to boost performance in every department. Which of the following, if true, most weakens the manager's argument?",
    image: null,
    options: [
      "A. Other departments have very different workflows and customer interaction needs than the sales team, such that a tool suited to sales tasks may not address the bottlenecks those departments face.",
      "B. The CRM software was expensive to license.",
      "C. The sales team also hired two new employees that quarter.",
      "D. The company has used three different CRM systems in the past."
    ],
    answer: "A"
  },

  {
    id: 138,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 683,
    discrimination: 1.44,
    timeLimit: 170,
    question: "A magazine surveyed its subscribers and found that 80% support a proposed new city tax. The magazine concludes that the majority of city residents support the tax. Which of the following best identifies a flaw in this reasoning?",
    image: null,
    options: [
      "A. The magazine's subscribers may not be representative of city residents as a whole, particularly if subscribership skews toward a particular income level or political viewpoint.",
      "B. The survey did not ask about other taxes.",
      "C. The magazine did not disclose its circulation numbers.",
      "D. The tax proposal has not yet been finalized."
    ],
    answer: "A"
  },

  {
    id: 139,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 690,
    discrimination: 1.45,
    timeLimit: 172,
    question: "A company introduced a wellness program offering gym memberships to employees, and it later reported that participating employees took fewer sick days than non-participating employees. Which of the following, if true, would most strengthen the claim that the wellness program caused the reduction in sick days?",
    image: null,
    options: [
      "A. Employees were assigned to the program randomly rather than opting in, and those who joined were not already healthier or more health-conscious than those who did not.",
      "B. The program costs the company money to run.",
      "C. Some non-participating employees also exercise regularly on their own.",
      "D. The program has been running for two years."
    ],
    answer: "A"
  },

  {
    id: 140,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.46,
    timeLimit: 175,
    question: "Every product in Warehouse A that failed quality inspection was manufactured in Factory X, and no product manufactured in Factory Y has ever failed quality inspection at Warehouse A. If a product in Warehouse A passed quality inspection, which of the following must be true?",
    image: null,
    options: [
      "A. The product was manufactured in Factory Y.",
      "B. The product could have been manufactured in either Factory X or Factory Y.",
      "C. The product was not manufactured in Factory X.",
      "D. The product was manufactured in Factory X."
    ],
    answer: "B"
  },

  {
    id: 141,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 710,
    discrimination: 1.48,
    timeLimit: 178,
    question: "A retailer's online sales increased by 25% in the month after it redesigned its website's checkout process. The retailer attributes the increase entirely to the redesign. Which of the following, if true, most weakens this conclusion?",
    image: null,
    options: [
      "A. The redesign launched at the start of the holiday shopping season, when online sales for most retailers typically rise significantly regardless of website changes.",
      "B. The redesign took three months to develop.",
      "C. Some customers complained about the new checkout process.",
      "D. The retailer also sells in physical stores."
    ],
    answer: "A"
  },

  {
    id: 142,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 720,
    discrimination: 1.5,
    timeLimit: 180,
    question: "A researcher argues that since twins raised in different households often develop similar personality traits, personality must be determined primarily by genetics rather than environment. Which of the following, if true, would most weaken this argument?",
    image: null,
    options: [
      "A. Twins raised in different households, even when unrelated to each other, often still experience broadly similar environmental influences, such as similar cultural norms or parenting styles common in their society.",
      "B. Some twins are raised in the same household.",
      "C. Personality traits are difficult to measure precisely.",
      "D. Genetics also influences physical appearance."
    ],
    answer: "A"
  },

  {
    id: 143,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 730,
    discrimination: 1.52,
    timeLimit: 183,
    question: "A city is debating whether to convert a lightly used one-way street into a two-way street, on the theory that this will ease traffic congestion on the parallel main avenue. Which of the following would be most useful to establish before making this decision?",
    image: null,
    options: [
      "A. Whether drivers currently using the main avenue would be willing and able to reroute through the converted street given its width and the location of their typical destinations.",
      "B. The original construction date of the one-way street.",
      "C. The number of streetlights on the one-way street.",
      "D. Public opinion on the color of new street signage."
    ],
    answer: "A"
  },

  {
    id: 144,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 740,
    discrimination: 1.55,
    timeLimit: 186,
    question: "A vaccine that is highly effective at preventing severe illness was introduced nationwide, yet hospital admissions for the illness it targets did not decrease in the year following its introduction. Which of the following, if true, best resolves this apparent paradox?",
    image: null,
    options: [
      "A. Vaccination rates remained very low in the first year because of limited supply and distribution delays, so most of the population remained unvaccinated during that period.",
      "B. The vaccine requires two doses.",
      "C. The illness can also be prevented through other measures.",
      "D. The vaccine was developed quickly."
    ],
    answer: "A"
  },

  {
    id: 145,
    section: "Verbal",
    topic: "Critical Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.6,
    timeLimit: 190,
    question: "A business consultant argues that a struggling retail chain must either cut employee wages or close stores, since profits have fallen and there is no other way to reduce costs. Which of the following best identifies a flaw in the consultant's argument?",
    image: null,
    options: [
      "A. The argument presents only two options as though they were the only possibilities, while ignoring other potential cost-saving measures, such as renegotiating supplier contracts or reducing store operating hours.",
      "B. The argument does not specify how much profits have fallen.",
      "C. The argument assumes all stores are equally unprofitable.",
      "D. The argument does not mention employee morale."
    ],
    answer: "A"
  },

  {
    id: 146,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E1",
    passage: "In the early twentieth century, many factories operated with a rigid division of labor, where each worker performed a single repetitive task on an assembly line. This approach, pioneered in the automobile industry, dramatically increased production speed and lowered costs, making manufactured goods more affordable to the average consumer. However, workers often found the repetitive tasks monotonous, and some studies later suggested that worker satisfaction and, in some cases, product quality could suffer under such rigid systems. In response, some companies began experimenting with team-based production models, where small groups of workers collaborated on multiple stages of assembly, aiming to balance efficiency with worker engagement.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 150,
    question: "Which of the following best states the main idea of the passage?",
    image: null,
    options: [
      "A. Assembly line production was a failed experiment that companies quickly abandoned.",
      "B. The introduction of assembly line production increased efficiency but also raised concerns that later led some companies to explore alternative models.",
      "C. Team-based production is always more efficient than assembly line production.",
      "D. Worker satisfaction is irrelevant to manufacturing efficiency."
    ],
    answer: "B"
  },

  {
    id: 147,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E1",
    passage: "In the early twentieth century, many factories operated with a rigid division of labor, where each worker performed a single repetitive task on an assembly line. This approach, pioneered in the automobile industry, dramatically increased production speed and lowered costs, making manufactured goods more affordable to the average consumer. However, workers often found the repetitive tasks monotonous, and some studies later suggested that worker satisfaction and, in some cases, product quality could suffer under such rigid systems. In response, some companies began experimenting with team-based production models, where small groups of workers collaborated on multiple stages of assembly, aiming to balance efficiency with worker engagement.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 410,
    discrimination: 0.85,
    timeLimit: 145,
    question: "According to the passage, what was one effect of assembly line production on consumers?",
    image: null,
    options: [
      "A. It made manufactured goods more affordable.",
      "B. It made goods more expensive.",
      "C. It eliminated the need for factories.",
      "D. It increased worker satisfaction."
    ],
    answer: "A"
  },

  {
    id: 148,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E1",
    passage: "In the early twentieth century, many factories operated with a rigid division of labor, where each worker performed a single repetitive task on an assembly line. This approach, pioneered in the automobile industry, dramatically increased production speed and lowered costs, making manufactured goods more affordable to the average consumer. However, workers often found the repetitive tasks monotonous, and some studies later suggested that worker satisfaction and, in some cases, product quality could suffer under such rigid systems. In response, some companies began experimenting with team-based production models, where small groups of workers collaborated on multiple stages of assembly, aiming to balance efficiency with worker engagement.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.86,
    timeLimit: 155,
    question: "It can be inferred from the passage that team-based production models were introduced primarily to",
    image: null,
    options: [
      "A. increase production speed beyond that of assembly lines.",
      "B. address concerns related to worker monotony and its potential effects.",
      "C. eliminate the automobile industry's dominance.",
      "D. reduce the cost of manufactured goods further."
    ],
    answer: "B"
  },

  {
    id: 149,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E2",
    passage: "Urban heat islands occur when cities experience significantly higher temperatures than surrounding rural areas, largely due to the abundance of pavement and buildings that absorb and retain heat. This effect can increase energy consumption, as residents rely more heavily on air conditioning, and can also worsen air quality. To counter this, some cities have begun installing green roofs, covered with vegetation, which help insulate buildings and reduce surrounding air temperatures. While green roofs require more maintenance than traditional roofing, proponents argue that the long-term benefits, including reduced energy costs and improved air quality, outweigh the additional upkeep.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 430,
    discrimination: 0.86,
    timeLimit: 148,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. explaining the causes of urban heat islands and describing one proposed solution.",
      "B. arguing that green roofs are too costly to be practical.",
      "C. comparing rural and urban energy consumption patterns.",
      "D. describing the history of roofing materials."
    ],
    answer: "A"
  },

  {
    id: 150,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E2",
    passage: "Urban heat islands occur when cities experience significantly higher temperatures than surrounding rural areas, largely due to the abundance of pavement and buildings that absorb and retain heat. This effect can increase energy consumption, as residents rely more heavily on air conditioning, and can also worsen air quality. To counter this, some cities have begun installing green roofs, covered with vegetation, which help insulate buildings and reduce surrounding air temperatures. While green roofs require more maintenance than traditional roofing, proponents argue that the long-term benefits, including reduced energy costs and improved air quality, outweigh the additional upkeep.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.87,
    timeLimit: 145,
    question: "According to the passage, what is one consequence of urban heat islands?",
    image: null,
    options: [
      "A. Decreased air conditioning use.",
      "B. Increased energy consumption.",
      "C. Lower rural temperatures.",
      "D. Reduced building maintenance."
    ],
    answer: "B"
  },

  {
    id: 151,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E2",
    passage: "Urban heat islands occur when cities experience significantly higher temperatures than surrounding rural areas, largely due to the abundance of pavement and buildings that absorb and retain heat. This effect can increase energy consumption, as residents rely more heavily on air conditioning, and can also worsen air quality. To counter this, some cities have begun installing green roofs, covered with vegetation, which help insulate buildings and reduce surrounding air temperatures. While green roofs require more maintenance than traditional roofing, proponents argue that the long-term benefits, including reduced energy costs and improved air quality, outweigh the additional upkeep.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 450,
    discrimination: 0.87,
    timeLimit: 152,
    question: "The passage suggests that proponents of green roofs believe that",
    image: null,
    options: [
      "A. the additional maintenance required is not worth the benefits.",
      "B. the long-term benefits justify the extra maintenance involved.",
      "C. green roofs eliminate the need for air conditioning entirely.",
      "D. green roofs are cheaper to install than traditional roofs."
    ],
    answer: "B"
  },

  {
    id: 152,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E3",
    passage: "The printing press, introduced in Europe in the fifteenth century, transformed the way information spread across society. Before its invention, books were copied by hand, a slow and expensive process that limited literacy largely to the wealthy and religious institutions. The printing press allowed books to be produced far more quickly and cheaply, which contributed to rising literacy rates and the wider circulation of new ideas. Some historians argue that this increased access to information played a role in later social and political movements, as more people gained the ability to read and share differing viewpoints.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 460,
    discrimination: 0.88,
    timeLimit: 148,
    question: "The main idea of the passage is that",
    image: null,
    options: [
      "A. the printing press had little lasting impact on society.",
      "B. the printing press made books cheaper but did not affect literacy.",
      "C. the printing press significantly increased access to information and may have influenced later social change.",
      "D. handwritten books were more accurate than printed ones."
    ],
    answer: "C"
  },

  {
    id: 153,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E3",
    passage: "The printing press, introduced in Europe in the fifteenth century, transformed the way information spread across society. Before its invention, books were copied by hand, a slow and expensive process that limited literacy largely to the wealthy and religious institutions. The printing press allowed books to be produced far more quickly and cheaply, which contributed to rising literacy rates and the wider circulation of new ideas. Some historians argue that this increased access to information played a role in later social and political movements, as more people gained the ability to read and share differing viewpoints.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 467,
    discrimination: 0.88,
    timeLimit: 145,
    question: "According to the passage, before the printing press, literacy was largely limited to",
    image: null,
    options: [
      "A. factory workers.",
      "B. the wealthy and religious institutions.",
      "C. rural farmers.",
      "D. government officials only."
    ],
    answer: "B"
  },

  {
    id: 154,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E3",
    passage: "The printing press, introduced in Europe in the fifteenth century, transformed the way information spread across society. Before its invention, books were copied by hand, a slow and expensive process that limited literacy largely to the wealthy and religious institutions. The printing press allowed books to be produced far more quickly and cheaply, which contributed to rising literacy rates and the wider circulation of new ideas. Some historians argue that this increased access to information played a role in later social and political movements, as more people gained the ability to read and share differing viewpoints.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 473,
    discrimination: 0.89,
    timeLimit: 150,
    question: "It can be inferred from the passage that increased literacy rates",
    image: null,
    options: [
      "A. had no connection to later social or political movements.",
      "B. may have contributed to the spread of differing viewpoints that influenced later movements.",
      "C. decreased the circulation of new ideas.",
      "D. were caused entirely by government policy."
    ],
    answer: "B"
  },

  {
    id: 155,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E4",
    passage: "Researchers have long studied the phenomenon known as the placebo effect, in which patients experience real improvements in symptoms after receiving a treatment with no active therapeutic ingredient, simply because they believe they are receiving effective treatment. This effect is not merely imaginary; studies using brain imaging have shown measurable changes in brain activity among patients given placebos. Understanding the placebo effect is important in clinical trials, where new drugs must be shown to outperform a placebo before they can be considered genuinely effective, ensuring that any observed benefit is due to the drug itself rather than patient belief alone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 480,
    discrimination: 0.89,
    timeLimit: 148,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. proving that all medical treatments are ineffective.",
      "B. explaining the placebo effect and its relevance to clinical trials.",
      "C. arguing that placebos should replace real medication.",
      "D. describing how brain imaging technology works."
    ],
    answer: "B"
  },

  {
    id: 156,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E4",
    passage: "Researchers have long studied the phenomenon known as the placebo effect, in which patients experience real improvements in symptoms after receiving a treatment with no active therapeutic ingredient, simply because they believe they are receiving effective treatment. This effect is not merely imaginary; studies using brain imaging have shown measurable changes in brain activity among patients given placebos. Understanding the placebo effect is important in clinical trials, where new drugs must be shown to outperform a placebo before they can be considered genuinely effective, ensuring that any observed benefit is due to the drug itself rather than patient belief alone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 484,
    discrimination: 0.9,
    timeLimit: 145,
    question: "According to the passage, what has brain imaging shown about the placebo effect?",
    image: null,
    options: [
      "A. It has no measurable effect on the brain.",
      "B. It produces measurable changes in brain activity.",
      "C. It only affects the brain in children.",
      "D. It causes permanent brain damage."
    ],
    answer: "B"
  },

  {
    id: 157,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E4",
    passage: "Researchers have long studied the phenomenon known as the placebo effect, in which patients experience real improvements in symptoms after receiving a treatment with no active therapeutic ingredient, simply because they believe they are receiving effective treatment. This effect is not merely imaginary; studies using brain imaging have shown measurable changes in brain activity among patients given placebos. Understanding the placebo effect is important in clinical trials, where new drugs must be shown to outperform a placebo before they can be considered genuinely effective, ensuring that any observed benefit is due to the drug itself rather than patient belief alone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 488,
    discrimination: 0.9,
    timeLimit: 150,
    question: "It can be inferred from the passage that in clinical trials, comparing a new drug to a placebo is important because it helps researchers",
    image: null,
    options: [
      "A. eliminate the need for further testing.",
      "B. determine that patients are imagining their symptoms.",
      "C. distinguish the drug's actual effect from improvements caused by patient belief.",
      "D. reduce the cost of drug development."
    ],
    answer: "C"
  },

  {
    id: 158,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E5",
    passage: "A common concept in economics is opportunity cost, which refers to the value of the next best alternative that a person or business gives up when making a choice. For example, if a farmer decides to plant wheat on a plot of land, the opportunity cost is the profit that could have been earned by planting a different crop, such as corn, on that same land. Recognizing opportunity cost helps individuals and businesses make more informed decisions, since focusing only on the direct costs of a choice can obscure the value of alternatives that are being foregone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 0.91,
    timeLimit: 148,
    question: "The main purpose of the passage is to",
    image: null,
    options: [
      "A. explain the concept of opportunity cost and its usefulness in decision-making.",
      "B. argue that farmers should always plant corn instead of wheat.",
      "C. describe the history of economic theory.",
      "D. compare the profitability of different crops."
    ],
    answer: "A"
  },

  {
    id: 159,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E5",
    passage: "A common concept in economics is opportunity cost, which refers to the value of the next best alternative that a person or business gives up when making a choice. For example, if a farmer decides to plant wheat on a plot of land, the opportunity cost is the profit that could have been earned by planting a different crop, such as corn, on that same land. Recognizing opportunity cost helps individuals and businesses make more informed decisions, since focusing only on the direct costs of a choice can obscure the value of alternatives that are being foregone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 486,
    discrimination: 0.91,
    timeLimit: 145,
    question: "According to the passage, the opportunity cost of planting wheat on a plot of land is",
    image: null,
    options: [
      "A. the total cost of farming equipment.",
      "B. the profit that could have been earned from planting an alternative crop on that land.",
      "C. the price of wheat in the market.",
      "D. the cost of fertilizer used."
    ],
    answer: "B"
  },

  {
    id: 160,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-E5",
    passage: "A common concept in economics is opportunity cost, which refers to the value of the next best alternative that a person or business gives up when making a choice. For example, if a farmer decides to plant wheat on a plot of land, the opportunity cost is the profit that could have been earned by planting a different crop, such as corn, on that same land. Recognizing opportunity cost helps individuals and businesses make more informed decisions, since focusing only on the direct costs of a choice can obscure the value of alternatives that are being foregone.",
    topic: "Reading Comprehension",
    difficultyLevel: "Easy",
    difficultyScore: 489,
    discrimination: 0.92,
    timeLimit: 150,
    question: "It can be inferred from the passage that focusing only on direct costs when making a decision",
    image: null,
    options: [
      "A. always leads to the best possible outcome.",
      "B. may cause a person to overlook the value of foregone alternatives.",
      "C. is the only way to calculate opportunity cost.",
      "D. has no effect on decision-making."
    ],
    answer: "B"
  },

  {
    id: 161,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M1",
    passage: "Behavioral economists have documented a phenomenon called loss aversion, in which people tend to weigh the pain of losing something more heavily than the pleasure of gaining an equivalent amount. This asymmetry can influence decisions in markets: for instance, investors may hold onto declining stocks longer than is rational, hoping to avoid realizing a loss, even when evidence suggests the stock is unlikely to recover. Some economists argue that loss aversion helps explain why consumers respond more strongly to price increases than to equivalent price decreases, a pattern that has implications for how businesses set and adjust prices. Critics, however, caution that loss aversion, while well documented in controlled experiments, may operate differently in complex real-world markets where many other factors influence decisions simultaneously.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 500,
    discrimination: 1.1,
    timeLimit: 170,
    question: "The primary purpose of the passage is to",
    image: null,
    options: [
      "A. prove that investors always make irrational decisions.",
      "B. introduce the concept of loss aversion, discuss its market implications, and note a caveat about its real-world applicability.",
      "C. argue that businesses should never raise prices.",
      "D. describe the history of behavioral economics as a discipline."
    ],
    answer: "B"
  },

  {
    id: 162,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M1",
    passage: "Behavioral economists have documented a phenomenon called loss aversion, in which people tend to weigh the pain of losing something more heavily than the pleasure of gaining an equivalent amount. This asymmetry can influence decisions in markets: for instance, investors may hold onto declining stocks longer than is rational, hoping to avoid realizing a loss, even when evidence suggests the stock is unlikely to recover. Some economists argue that loss aversion helps explain why consumers respond more strongly to price increases than to equivalent price decreases, a pattern that has implications for how businesses set and adjust prices. Critics, however, caution that loss aversion, while well documented in controlled experiments, may operate differently in complex real-world markets where many other factors influence decisions simultaneously.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 512,
    discrimination: 1.11,
    timeLimit: 165,
    question: "According to the passage, loss aversion may cause investors to",
    image: null,
    options: [
      "A. sell stocks too quickly.",
      "B. hold onto declining stocks longer than is rational.",
      "C. avoid the stock market entirely.",
      "D. invest only in stocks that are increasing in value."
    ],
    answer: "B"
  },

  {
    id: 163,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M1",
    passage: "Behavioral economists have documented a phenomenon called loss aversion, in which people tend to weigh the pain of losing something more heavily than the pleasure of gaining an equivalent amount. This asymmetry can influence decisions in markets: for instance, investors may hold onto declining stocks longer than is rational, hoping to avoid realizing a loss, even when evidence suggests the stock is unlikely to recover. Some economists argue that loss aversion helps explain why consumers respond more strongly to price increases than to equivalent price decreases, a pattern that has implications for how businesses set and adjust prices. Critics, however, caution that loss aversion, while well documented in controlled experiments, may operate differently in complex real-world markets where many other factors influence decisions simultaneously.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 525,
    discrimination: 1.12,
    timeLimit: 175,
    question: "The passage suggests that critics of applying loss aversion to real-world markets believe that",
    image: null,
    options: [
      "A. loss aversion has never been demonstrated in any experiment.",
      "B. laboratory findings on loss aversion may not translate straightforwardly to markets where multiple factors interact.",
      "C. consumers never respond to price changes.",
      "D. businesses should ignore behavioral economics entirely."
    ],
    answer: "B"
  },

  {
    id: 164,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M2",
    passage: "Coral reefs, often called the rainforests of the sea due to their biodiversity, are highly sensitive to changes in ocean temperature. When water temperatures rise even slightly above normal for a sustained period, corals can expel the symbiotic algae living within their tissues, a process known as bleaching, which leaves the coral white and vulnerable to disease. While corals can sometimes recover if temperatures return to normal quickly, repeated or prolonged bleaching events can lead to widespread coral death. Some researchers have identified certain coral species that show greater heat tolerance, possibly due to differences in the algae they host, and are studying whether these more resilient corals could be used to help restore damaged reefs, though such restoration efforts remain in early experimental stages.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 538,
    discrimination: 1.12,
    timeLimit: 170,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. explaining coral bleaching, its causes and consequences, and early research into more resilient coral species.",
      "B. arguing that coral reefs cannot be saved under any circumstances.",
      "C. describing the diet of coral reef fish.",
      "D. comparing ocean temperatures across different decades."
    ],
    answer: "A"
  },

  {
    id: 165,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M2",
    passage: "Coral reefs, often called the rainforests of the sea due to their biodiversity, are highly sensitive to changes in ocean temperature. When water temperatures rise even slightly above normal for a sustained period, corals can expel the symbiotic algae living within their tissues, a process known as bleaching, which leaves the coral white and vulnerable to disease. While corals can sometimes recover if temperatures return to normal quickly, repeated or prolonged bleaching events can lead to widespread coral death. Some researchers have identified certain coral species that show greater heat tolerance, possibly due to differences in the algae they host, and are studying whether these more resilient corals could be used to help restore damaged reefs, though such restoration efforts remain in early experimental stages.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 550,
    discrimination: 1.13,
    timeLimit: 165,
    question: "According to the passage, coral bleaching occurs when",
    image: null,
    options: [
      "A. corals are physically damaged by ships.",
      "B. corals expel symbiotic algae in response to sustained higher water temperatures.",
      "C. corals are overfed by nearby marine life.",
      "D. ocean salinity decreases suddenly."
    ],
    answer: "B"
  },

  {
    id: 166,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M2",
    passage: "Coral reefs, often called the rainforests of the sea due to their biodiversity, are highly sensitive to changes in ocean temperature. When water temperatures rise even slightly above normal for a sustained period, corals can expel the symbiotic algae living within their tissues, a process known as bleaching, which leaves the coral white and vulnerable to disease. While corals can sometimes recover if temperatures return to normal quickly, repeated or prolonged bleaching events can lead to widespread coral death. Some researchers have identified certain coral species that show greater heat tolerance, possibly due to differences in the algae they host, and are studying whether these more resilient corals could be used to help restore damaged reefs, though such restoration efforts remain in early experimental stages.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 562,
    discrimination: 1.14,
    timeLimit: 178,
    question: "It can be inferred from the passage that the heat-tolerant coral species mentioned",
    image: null,
    options: [
      "A. are definitely immune to all effects of rising ocean temperatures.",
      "B. are being studied as a possible, though not yet proven, approach to reef restoration.",
      "C. have already been used successfully to restore all damaged reefs.",
      "D. do not host any symbiotic algae at all."
    ],
    answer: "B"
  },

  {
    id: 167,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M3",
    passage: "City planners have increasingly promoted mixed-use development, in which residential, commercial, and office spaces coexist within the same neighborhood or even the same building, as an alternative to the strict separation of zones that characterized much twentieth-century urban planning. Proponents argue that mixed-use development reduces reliance on cars, since residents can walk to nearby shops and workplaces, and fosters more vibrant, active neighborhoods throughout the day. Critics counter that increased density in mixed-use areas can strain local infrastructure, such as water and sewage systems, if not carefully planned, and that not all residents want to live in close proximity to commercial activity, citing concerns about noise and traffic congestion at all hours.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.15,
    timeLimit: 170,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. presenting arguments for and against mixed-use development in cities.",
      "B. proving that mixed-use development eliminates all traffic congestion.",
      "C. describing the history of zoning laws.",
      "D. arguing that all cities should abandon zoning entirely."
    ],
    answer: "A"
  },

  {
    id: 168,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M3",
    passage: "City planners have increasingly promoted mixed-use development, in which residential, commercial, and office spaces coexist within the same neighborhood or even the same building, as an alternative to the strict separation of zones that characterized much twentieth-century urban planning. Proponents argue that mixed-use development reduces reliance on cars, since residents can walk to nearby shops and workplaces, and fosters more vibrant, active neighborhoods throughout the day. Critics counter that increased density in mixed-use areas can strain local infrastructure, such as water and sewage systems, if not carefully planned, and that not all residents want to live in close proximity to commercial activity, citing concerns about noise and traffic congestion at all hours.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 585,
    discrimination: 1.16,
    timeLimit: 165,
    question: "According to the passage, proponents of mixed-use development argue that it",
    image: null,
    options: [
      "A. increases reliance on cars.",
      "B. reduces reliance on cars and fosters more active neighborhoods.",
      "C. eliminates the need for any zoning regulation.",
      "D. is more expensive to build than single-use development."
    ],
    answer: "B"
  },

  {
    id: 169,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M3",
    passage: "City planners have increasingly promoted mixed-use development, in which residential, commercial, and office spaces coexist within the same neighborhood or even the same building, as an alternative to the strict separation of zones that characterized much twentieth-century urban planning. Proponents argue that mixed-use development reduces reliance on cars, since residents can walk to nearby shops and workplaces, and fosters more vibrant, active neighborhoods throughout the day. Critics counter that increased density in mixed-use areas can strain local infrastructure, such as water and sewage systems, if not carefully planned, and that not all residents want to live in close proximity to commercial activity, citing concerns about noise and traffic congestion at all hours.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 595,
    discrimination: 1.16,
    timeLimit: 178,
    question: "It can be inferred from the passage that critics of mixed-use development are primarily concerned with",
    image: null,
    options: [
      "A. the aesthetic appearance of mixed-use buildings.",
      "B. potential strain on infrastructure and quality-of-life concerns such as noise and traffic.",
      "C. the cost of residential rent in such neighborhoods.",
      "D. the historical origins of zoning laws."
    ],
    answer: "B"
  },

  {
    id: 170,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M4",
    passage: "As companies increasingly rely on algorithms to make decisions once made by humans, such as screening job applicants or approving loan applications, concerns have grown about the potential for these systems to perpetuate or even amplify existing biases. Because algorithms are often trained on historical data, they may learn patterns that reflect past discriminatory practices, even without any explicit reference to protected characteristics such as race or gender. Some researchers advocate for regular audits of algorithmic systems to detect unintended bias, while others argue that greater transparency about how algorithms reach their decisions, sometimes called explainability, is necessary before such systems should be trusted with high-stakes decisions.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.17,
    timeLimit: 170,
    question: "The main purpose of the passage is to",
    image: null,
    options: [
      "A. argue that algorithms should never be used for any decision-making.",
      "B. discuss concerns about algorithmic bias and proposed approaches to address it.",
      "C. describe how loan applications were processed before algorithms existed.",
      "D. prove that human decision-makers are always less biased than algorithms."
    ],
    answer: "B"
  },

  {
    id: 171,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M4",
    passage: "As companies increasingly rely on algorithms to make decisions once made by humans, such as screening job applicants or approving loan applications, concerns have grown about the potential for these systems to perpetuate or even amplify existing biases. Because algorithms are often trained on historical data, they may learn patterns that reflect past discriminatory practices, even without any explicit reference to protected characteristics such as race or gender. Some researchers advocate for regular audits of algorithmic systems to detect unintended bias, while others argue that greater transparency about how algorithms reach their decisions, sometimes called explainability, is necessary before such systems should be trusted with high-stakes decisions.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 613,
    discrimination: 1.18,
    timeLimit: 165,
    question: "According to the passage, algorithms may perpetuate bias because they",
    image: null,
    options: [
      "A. are programmed with explicit references to protected characteristics.",
      "B. are trained on historical data that may reflect past discriminatory patterns.",
      "C. are always less accurate than human judgment.",
      "D. cannot process large amounts of data."
    ],
    answer: "B"
  },

  {
    id: 172,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M4",
    passage: "As companies increasingly rely on algorithms to make decisions once made by humans, such as screening job applicants or approving loan applications, concerns have grown about the potential for these systems to perpetuate or even amplify existing biases. Because algorithms are often trained on historical data, they may learn patterns that reflect past discriminatory practices, even without any explicit reference to protected characteristics such as race or gender. Some researchers advocate for regular audits of algorithmic systems to detect unintended bias, while others argue that greater transparency about how algorithms reach their decisions, sometimes called explainability, is necessary before such systems should be trusted with high-stakes decisions.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 618,
    discrimination: 1.19,
    timeLimit: 178,
    question: "It can be inferred from the passage that advocates of \"explainability\" believe that",
    image: null,
    options: [
      "A. understanding how an algorithm reaches its decisions is important before relying on it for significant decisions.",
      "B. algorithmic decisions should never be reviewed.",
      "C. historical data should be discarded entirely when training algorithms.",
      "D. audits of algorithms are unnecessary if explainability is achieved."
    ],
    answer: "A"
  },

  {
    id: 173,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M5",
    passage: "Art historians have debated the extent to which the invention of photography in the nineteenth century influenced the development of later painting movements, such as Impressionism. Some scholars argue that because photography could capture a realistic likeness far more efficiently than a painted portrait, painters were freed to explore other concerns, such as the fleeting effects of light and color, rather than focusing primarily on precise representation. Other scholars are more skeptical of this narrative, noting that many Impressionist painters had already begun moving away from strict realism before photography became widely accessible, suggesting that the shift may have been driven more by internal developments within the art world than by competition from the new technology.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 610,
    discrimination: 1.18,
    timeLimit: 172,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. presenting a debate among art historians about photography's influence on the development of Impressionism.",
      "B. proving definitively that photography caused Impressionism.",
      "C. describing the technical process of nineteenth-century photography.",
      "D. arguing that Impressionist painters copied photographs directly."
    ],
    answer: "A"
  },

  {
    id: 174,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M5",
    passage: "Art historians have debated the extent to which the invention of photography in the nineteenth century influenced the development of later painting movements, such as Impressionism. Some scholars argue that because photography could capture a realistic likeness far more efficiently than a painted portrait, painters were freed to explore other concerns, such as the fleeting effects of light and color, rather than focusing primarily on precise representation. Other scholars are more skeptical of this narrative, noting that many Impressionist painters had already begun moving away from strict realism before photography became widely accessible, suggesting that the shift may have been driven more by internal developments within the art world than by competition from the new technology.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 615,
    discrimination: 1.19,
    timeLimit: 168,
    question: "According to the passage, some scholars argue that photography allowed painters to",
    image: null,
    options: [
      "A. abandon painting altogether.",
      "B. focus on aspects such as light and color rather than precise representation.",
      "C. paint more quickly than before.",
      "D. sell their paintings at higher prices."
    ],
    answer: "B"
  },

  {
    id: 175,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-M5",
    passage: "Art historians have debated the extent to which the invention of photography in the nineteenth century influenced the development of later painting movements, such as Impressionism. Some scholars argue that because photography could capture a realistic likeness far more efficiently than a painted portrait, painters were freed to explore other concerns, such as the fleeting effects of light and color, rather than focusing primarily on precise representation. Other scholars are more skeptical of this narrative, noting that many Impressionist painters had already begun moving away from strict realism before photography became widely accessible, suggesting that the shift may have been driven more by internal developments within the art world than by competition from the new technology.",
    topic: "Reading Comprehension",
    difficultyLevel: "Medium",
    difficultyScore: 620,
    discrimination: 1.2,
    timeLimit: 180,
    question: "It can be inferred from the passage that skeptical scholars believe the shift toward Impressionism",
    image: null,
    options: [
      "A. was caused entirely by the invention of photography.",
      "B. may have originated from developments within the art world that predated widespread photography.",
      "C. never actually occurred.",
      "D. was primarily an economic phenomenon."
    ],
    answer: "B"
  },

  {
    id: 176,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H1",
    passage: "Economists have long relied on models that assume individuals act as rational agents who consistently seek to maximize their own utility, a framework that has proven useful for generating precise, testable predictions about market behavior. However, the emergence of behavioral economics has challenged the universality of this assumption by documenting systematic ways in which real human decision-making departs from strict rationality, including susceptibility to cognitive biases and reliance on mental shortcuts, or heuristics, that can lead to predictable errors in judgment. Rather than abandoning rational-agent models entirely, many economists now advocate a middle path: retaining simplified rational models for their analytical tractability in certain contexts, while incorporating behavioral insights where deviations from rationality are large and systematic enough to meaningfully affect outcomes, such as in decisions involving retirement savings or long-term health behaviors, where present bias and other well-documented departures from rationality tend to be especially pronounced.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 200,
    question: "The primary purpose of the passage is to",
    image: null,
    options: [
      "A. argue that rational-agent models in economics should be discarded entirely in favor of behavioral models.",
      "B. describe a proposed synthesis in which traditional rational models and behavioral insights are each applied where most appropriate.",
      "C. prove that all human decisions are irrational.",
      "D. explain the history of how economic models are taught in universities."
    ],
    answer: "B"
  },

  {
    id: 177,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H1",
    passage: "Economists have long relied on models that assume individuals act as rational agents who consistently seek to maximize their own utility, a framework that has proven useful for generating precise, testable predictions about market behavior. However, the emergence of behavioral economics has challenged the universality of this assumption by documenting systematic ways in which real human decision-making departs from strict rationality, including susceptibility to cognitive biases and reliance on mental shortcuts, or heuristics, that can lead to predictable errors in judgment. Rather than abandoning rational-agent models entirely, many economists now advocate a middle path: retaining simplified rational models for their analytical tractability in certain contexts, while incorporating behavioral insights where deviations from rationality are large and systematic enough to meaningfully affect outcomes, such as in decisions involving retirement savings or long-term health behaviors, where present bias and other well-documented departures from rationality tend to be especially pronounced.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 645,
    discrimination: 1.42,
    timeLimit: 195,
    question: "According to the passage, behavioral economics has challenged traditional economic models by",
    image: null,
    options: [
      "A. proving that markets do not exist.",
      "B. documenting systematic departures from rationality, including cognitive biases and heuristics, in human decision-making.",
      "C. eliminating the need for any economic modeling.",
      "D. showing that all predictions of rational-agent models are false."
    ],
    answer: "B"
  },

  {
    id: 178,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H1",
    passage: "Economists have long relied on models that assume individuals act as rational agents who consistently seek to maximize their own utility, a framework that has proven useful for generating precise, testable predictions about market behavior. However, the emergence of behavioral economics has challenged the universality of this assumption by documenting systematic ways in which real human decision-making departs from strict rationality, including susceptibility to cognitive biases and reliance on mental shortcuts, or heuristics, that can lead to predictable errors in judgment. Rather than abandoning rational-agent models entirely, many economists now advocate a middle path: retaining simplified rational models for their analytical tractability in certain contexts, while incorporating behavioral insights where deviations from rationality are large and systematic enough to meaningfully affect outcomes, such as in decisions involving retirement savings or long-term health behaviors, where present bias and other well-documented departures from rationality tend to be especially pronounced.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 660,
    discrimination: 1.44,
    timeLimit: 210,
    question: "It can be inferred from the passage that present bias, as an example, is considered particularly relevant to retirement savings decisions because",
    image: null,
    options: [
      "A. retirement savings decisions involve no financial risk.",
      "B. such decisions involve long-term tradeoffs where the well-documented tendency to depart from strict rationality can be especially pronounced and consequential.",
      "C. retirement savings decisions are made only by economists.",
      "D. present bias has no measurable effect on any financial decisions."
    ],
    answer: "B"
  },

  {
    id: 179,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H2",
    passage: "Epigenetics is the study of heritable changes in gene expression that occur without alterations to the underlying DNA sequence itself, often resulting from chemical modifications, such as methylation, that can turn genes on or off in response to environmental factors. Some research suggests that certain epigenetic changes acquired during an organism's lifetime, such as those resulting from diet or stress exposure, may be passed on to offspring, a phenomenon that would complicate the traditional view that only DNA sequence changes are heritable across generations. However, this transgenerational inheritance of epigenetic marks remains controversial among scientists, in part because most epigenetic modifications are known to be reset during the formation of reproductive cells, and demonstrating that a given epigenetic change reliably survives this resetting process, is inherited, and produces a specific effect in subsequent generations requires exceptionally rigorous experimental controls that are difficult to achieve, particularly in long-lived organisms such as humans.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 670,
    discrimination: 1.45,
    timeLimit: 205,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. proving that all genetic traits are entirely determined by environmental factors.",
      "B. introducing epigenetics and discussing the scientific debate over whether certain epigenetic changes can be inherited across generations.",
      "C. describing the discovery of DNA's double helix structure.",
      "D. arguing that epigenetic research should be discontinued."
    ],
    answer: "B"
  },

  {
    id: 180,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H2",
    passage: "Epigenetics is the study of heritable changes in gene expression that occur without alterations to the underlying DNA sequence itself, often resulting from chemical modifications, such as methylation, that can turn genes on or off in response to environmental factors. Some research suggests that certain epigenetic changes acquired during an organism's lifetime, such as those resulting from diet or stress exposure, may be passed on to offspring, a phenomenon that would complicate the traditional view that only DNA sequence changes are heritable across generations. However, this transgenerational inheritance of epigenetic marks remains controversial among scientists, in part because most epigenetic modifications are known to be reset during the formation of reproductive cells, and demonstrating that a given epigenetic change reliably survives this resetting process, is inherited, and produces a specific effect in subsequent generations requires exceptionally rigorous experimental controls that are difficult to achieve, particularly in long-lived organisms such as humans.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 685,
    discrimination: 1.46,
    timeLimit: 198,
    question: "According to the passage, epigenetic changes typically involve",
    image: null,
    options: [
      "A. alterations to the DNA sequence itself.",
      "B. chemical modifications, such as methylation, that affect gene expression without changing the underlying DNA sequence.",
      "C. the complete removal of certain genes.",
      "D. changes that occur only in reproductive cells."
    ],
    answer: "B"
  },

  {
    id: 181,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H2",
    passage: "Epigenetics is the study of heritable changes in gene expression that occur without alterations to the underlying DNA sequence itself, often resulting from chemical modifications, such as methylation, that can turn genes on or off in response to environmental factors. Some research suggests that certain epigenetic changes acquired during an organism's lifetime, such as those resulting from diet or stress exposure, may be passed on to offspring, a phenomenon that would complicate the traditional view that only DNA sequence changes are heritable across generations. However, this transgenerational inheritance of epigenetic marks remains controversial among scientists, in part because most epigenetic modifications are known to be reset during the formation of reproductive cells, and demonstrating that a given epigenetic change reliably survives this resetting process, is inherited, and produces a specific effect in subsequent generations requires exceptionally rigorous experimental controls that are difficult to achieve, particularly in long-lived organisms such as humans.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.48,
    timeLimit: 215,
    question: "It can be inferred from the passage that one reason transgenerational epigenetic inheritance is difficult to demonstrate is that",
    image: null,
    options: [
      "A. epigenetic changes are usually permanent and never reset.",
      "B. most epigenetic modifications are reset during reproductive cell formation, making it hard to show that a specific change survives this process and reliably passes to offspring.",
      "C. scientists lack any interest in studying the subject.",
      "D. DNA sequencing technology does not yet exist."
    ],
    answer: "B"
  },

  {
    id: 182,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H3",
    passage: "Antitrust law in many jurisdictions has traditionally focused on preventing harm to consumers, typically measured through effects on prices, output, and product quality, a standard that has generally been straightforward to apply to industries selling physical goods at a clear price. The rise of large digital platforms, however, many of which offer core services to users at no direct monetary cost while generating revenue through advertising or data collection, has complicated this traditional framework, since a lack of price increases does not necessarily indicate an absence of consumer harm in such markets. Some legal scholars have proposed broadening the consumer welfare standard to account for factors such as reduced innovation, diminished data privacy, or decreased choice among competing platforms, while other scholars caution that such a broadened standard risks introducing excessive subjectivity into antitrust enforcement, potentially allowing regulators too much discretion in determining what qualifies as harmful conduct.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 710,
    discrimination: 1.5,
    timeLimit: 208,
    question: "The primary purpose of the passage is to",
    image: null,
    options: [
      "A. argue that antitrust law should be abolished for digital platforms entirely.",
      "B. describe how the traditional consumer welfare standard in antitrust law faces new challenges from digital platforms, and present a debate over how the standard might be adapted.",
      "C. prove that all digital platforms engage in anticompetitive behavior.",
      "D. explain the history of how prices are set in traditional industries."
    ],
    answer: "B"
  },

  {
    id: 183,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H3",
    passage: "Antitrust law in many jurisdictions has traditionally focused on preventing harm to consumers, typically measured through effects on prices, output, and product quality, a standard that has generally been straightforward to apply to industries selling physical goods at a clear price. The rise of large digital platforms, however, many of which offer core services to users at no direct monetary cost while generating revenue through advertising or data collection, has complicated this traditional framework, since a lack of price increases does not necessarily indicate an absence of consumer harm in such markets. Some legal scholars have proposed broadening the consumer welfare standard to account for factors such as reduced innovation, diminished data privacy, or decreased choice among competing platforms, while other scholars caution that such a broadened standard risks introducing excessive subjectivity into antitrust enforcement, potentially allowing regulators too much discretion in determining what qualifies as harmful conduct.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 720,
    discrimination: 1.51,
    timeLimit: 200,
    question: "According to the passage, the traditional consumer welfare standard in antitrust law has generally been measured through",
    image: null,
    options: [
      "A. a platform's advertising revenue.",
      "B. effects on prices, output, and product quality.",
      "C. the number of users a platform has.",
      "D. a company's stock price."
    ],
    answer: "B"
  },

  {
    id: 184,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H3",
    passage: "Antitrust law in many jurisdictions has traditionally focused on preventing harm to consumers, typically measured through effects on prices, output, and product quality, a standard that has generally been straightforward to apply to industries selling physical goods at a clear price. The rise of large digital platforms, however, many of which offer core services to users at no direct monetary cost while generating revenue through advertising or data collection, has complicated this traditional framework, since a lack of price increases does not necessarily indicate an absence of consumer harm in such markets. Some legal scholars have proposed broadening the consumer welfare standard to account for factors such as reduced innovation, diminished data privacy, or decreased choice among competing platforms, while other scholars caution that such a broadened standard risks introducing excessive subjectivity into antitrust enforcement, potentially allowing regulators too much discretion in determining what qualifies as harmful conduct.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 735,
    discrimination: 1.53,
    timeLimit: 218,
    question: "It can be inferred from the passage that scholars who caution against broadening the consumer welfare standard are primarily concerned that",
    image: null,
    options: [
      "A. digital platforms cause no harm to consumers under any standard.",
      "B. a broadened standard could give regulators excessive discretion in judging what constitutes harmful conduct.",
      "C. traditional industries no longer need antitrust protection.",
      "D. advertising revenue should be regulated directly."
    ],
    answer: "B"
  },

  {
    id: 185,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H4",
    passage: "Studies of decision-making under uncertainty have shown that people often rely on an intuitive, fast mode of thinking, sometimes contrasted with a slower, more deliberate mode of reasoning that requires greater cognitive effort. While the intuitive mode allows for quick judgments that are often adequate in familiar situations, it can also produce systematic errors when a situation superficially resembles a familiar pattern but actually differs from it in some important respect that the intuitive mode fails to detect. Some researchers have proposed that training individuals to recognize situations where their intuitive judgment is likely to be unreliable, and to deliberately switch to the slower mode of reasoning in those cases, could reduce decision-making errors, though critics note that reliably identifying such situations in real time, without the benefit of hindsight, may itself be a significant practical challenge.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.47,
    timeLimit: 205,
    question: "The passage is primarily concerned with",
    image: null,
    options: [
      "A. describing two modes of thinking, explaining when the faster mode can lead to errors, and discussing a proposed remedy along with a practical challenge to it.",
      "B. proving that intuitive thinking is always superior to deliberate reasoning.",
      "C. arguing that all decisions should be made using slow, deliberate reasoning.",
      "D. describing the biological structure of the human brain in detail."
    ],
    answer: "A"
  },

  {
    id: 186,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H4",
    passage: "Studies of decision-making under uncertainty have shown that people often rely on an intuitive, fast mode of thinking, sometimes contrasted with a slower, more deliberate mode of reasoning that requires greater cognitive effort. While the intuitive mode allows for quick judgments that are often adequate in familiar situations, it can also produce systematic errors when a situation superficially resembles a familiar pattern but actually differs from it in some important respect that the intuitive mode fails to detect. Some researchers have proposed that training individuals to recognize situations where their intuitive judgment is likely to be unreliable, and to deliberately switch to the slower mode of reasoning in those cases, could reduce decision-making errors, though critics note that reliably identifying such situations in real time, without the benefit of hindsight, may itself be a significant practical challenge.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 715,
    discrimination: 1.49,
    timeLimit: 198,
    question: "According to the passage, the intuitive mode of thinking can produce errors when",
    image: null,
    options: [
      "A. a person has too much time to make a decision.",
      "B. a situation superficially resembles a familiar pattern but differs from it in an important way that intuition fails to detect.",
      "C. a person is using the slower, deliberate mode of reasoning.",
      "D. no cognitive effort is required at all."
    ],
    answer: "B"
  },

  {
    id: 187,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H4",
    passage: "Studies of decision-making under uncertainty have shown that people often rely on an intuitive, fast mode of thinking, sometimes contrasted with a slower, more deliberate mode of reasoning that requires greater cognitive effort. While the intuitive mode allows for quick judgments that are often adequate in familiar situations, it can also produce systematic errors when a situation superficially resembles a familiar pattern but actually differs from it in some important respect that the intuitive mode fails to detect. Some researchers have proposed that training individuals to recognize situations where their intuitive judgment is likely to be unreliable, and to deliberately switch to the slower mode of reasoning in those cases, could reduce decision-making errors, though critics note that reliably identifying such situations in real time, without the benefit of hindsight, may itself be a significant practical challenge.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 730,
    discrimination: 1.52,
    timeLimit: 212,
    question: "It can be inferred from the passage that critics of the proposed training approach are skeptical primarily because",
    image: null,
    options: [
      "A. they believe intuitive thinking should never be used.",
      "B. reliably recognizing, in the moment, situations where intuition is unreliable may be difficult without the benefit of hindsight.",
      "C. deliberate reasoning is always faster than intuitive thinking.",
      "D. training programs are too expensive to implement."
    ],
    answer: "B"
  },

  {
    id: 188,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H5",
    passage: "When companies pursue vertical integration, acquiring suppliers or distributors rather than relying on external partners, they often cite the goal of reducing transaction costs, such as the expenses associated with negotiating and enforcing contracts with outside firms. However, vertical integration also carries potential downsides, including reduced flexibility, since a company that owns its supplier may find it more difficult to switch to a better or cheaper alternative if market conditions change, and increased organizational complexity, as managing an expanded set of internal operations can strain a company's existing management capabilities. Some scholars argue that the decision to vertically integrate should therefore depend heavily on the specific characteristics of the transaction in question, such as how frequently it recurs and how much specialized, relationship-specific investment it requires, rather than being treated as a generally superior strategy applicable across all circumstances.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 740,
    discrimination: 1.55,
    timeLimit: 210,
    question: "The primary purpose of the passage is to",
    image: null,
    options: [
      "A. argue that vertical integration is always the best strategic choice for a company.",
      "B. explain the potential benefits and drawbacks of vertical integration and suggest that the decision should depend on specific transaction characteristics.",
      "C. describe the history of supply chain management.",
      "D. prove that all companies should rely entirely on external suppliers."
    ],
    answer: "B"
  },

  {
    id: 189,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H5",
    passage: "When companies pursue vertical integration, acquiring suppliers or distributors rather than relying on external partners, they often cite the goal of reducing transaction costs, such as the expenses associated with negotiating and enforcing contracts with outside firms. However, vertical integration also carries potential downsides, including reduced flexibility, since a company that owns its supplier may find it more difficult to switch to a better or cheaper alternative if market conditions change, and increased organizational complexity, as managing an expanded set of internal operations can strain a company's existing management capabilities. Some scholars argue that the decision to vertically integrate should therefore depend heavily on the specific characteristics of the transaction in question, such as how frequently it recurs and how much specialized, relationship-specific investment it requires, rather than being treated as a generally superior strategy applicable across all circumstances.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 745,
    discrimination: 1.57,
    timeLimit: 200,
    question: "According to the passage, one potential downside of vertical integration is",
    image: null,
    options: [
      "A. increased flexibility to switch suppliers.",
      "B. reduced flexibility and increased organizational complexity.",
      "C. lower transaction costs.",
      "D. simplified management structures."
    ],
    answer: "B"
  },

  {
    id: 190,
    section: "Verbal",
    type: "readingComprehension",
    passageId: "RC-H5",
    passage: "When companies pursue vertical integration, acquiring suppliers or distributors rather than relying on external partners, they often cite the goal of reducing transaction costs, such as the expenses associated with negotiating and enforcing contracts with outside firms. However, vertical integration also carries potential downsides, including reduced flexibility, since a company that owns its supplier may find it more difficult to switch to a better or cheaper alternative if market conditions change, and increased organizational complexity, as managing an expanded set of internal operations can strain a company's existing management capabilities. Some scholars argue that the decision to vertically integrate should therefore depend heavily on the specific characteristics of the transaction in question, such as how frequently it recurs and how much specialized, relationship-specific investment it requires, rather than being treated as a generally superior strategy applicable across all circumstances.",
    topic: "Reading Comprehension",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.6,
    timeLimit: 220,
    question: "It can be inferred from the passage that transactions requiring substantial relationship-specific investment are",
    image: null,
    options: [
      "A. never suitable candidates for vertical integration.",
      "B. more likely to be cited by scholars as cases where vertical integration may be particularly appropriate.",
      "C. irrelevant to the decision of whether to vertically integrate.",
      "D. always less costly than transactions requiring no such investment."
    ],
    answer: "B"
  }

];

export default gmatVerbal;